import { useEffect, useState } from 'react';
import { ler, palavra, setOverlay } from '../realtime/desempenho';

/** Overlay F9. O servidor manda a palavra; o cliente só desenha. */
export function DesempenhoGump() {
  const [snap, setSnap] = useState(ler);
  useEffect(() => {
    setOverlay(true);
    const id = window.setInterval(() => setSnap(ler()), 500);
    return () => {
      setOverlay(false);
      window.clearInterval(id);
    };
  }, []);
  const cor = snap.saude === 2 ? '#e35d5d' : snap.saude === 1 ? '#e0b15a' : '#7dcea0';
  return (
    <div
      style={{
        position: 'absolute',
        left: 14,
        top: 58,
        zIndex: 20,
        minWidth: 180,
        padding: '8px 10px',
        background: 'rgba(12, 10, 8, 0.82)',
        border: '1px solid rgba(201, 162, 39, 0.45)',
        color: '#f4ead2',
        font: '12px/1.35 ui-monospace, monospace',
        pointerEvents: 'none'
      }}
    >
      <div>mundo {snap.esperaMs} ms · <b style={{ color: cor }}>{palavra(snap.saude)}</b></div>
      <div>fps {snap.fps.toFixed(0)}</div>
      {snap.salaP99 > 0 && <div>sala p99 {(snap.salaP99 / 10).toFixed(1)} ms</div>}
    </div>
  );
}
